var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "message-box dialog-mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClickOutSide.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "dialog-box" }, [
        _c("div", { staticClass: "section dialog-header" }, [
          _c("h1", [_vm._v(_vm._s(_vm.$t("colorThemeDialog.title")))]),
        ]),
        _c("div", { staticClass: "section dialog-body" }, [
          _c("h2", [_vm._v(_vm._s(_vm.$t("colorThemeDialog.description")))]),
          _c("div", { staticClass: "setting-container" }, [
            _c(
              "select",
              {
                domProps: { value: _vm.theme },
                on: {
                  change: function ($event) {
                    return _vm.onSelectColorTheme($event)
                  },
                },
              },
              [
                _c("option", { attrs: { value: "", disabled: "" } }, [
                  _vm._v(_vm._s(_vm.$t("colorThemeDialog.selectPlaceholder"))),
                ]),
                _c("option", { attrs: { value: "default" } }, [
                  _vm._v(_vm._s(_vm.$t("colorThemeDialog.themes.light"))),
                ]),
                _c("option", { attrs: { value: "dark" } }, [
                  _vm._v(_vm._s(_vm.$t("colorThemeDialog.themes.dark"))),
                ]),
                _c("option", { attrs: { value: "sepia" } }, [
                  _vm._v(_vm._s(_vm.$t("colorThemeDialog.themes.sepia"))),
                ]),
                _c("option", { attrs: { value: "blackboard" } }, [
                  _vm._v(_vm._s(_vm.$t("colorThemeDialog.themes.blackboard"))),
                ]),
                _c("option", { attrs: { value: "bold" } }, [
                  _vm._v(_vm._s(_vm.$t("colorThemeDialog.themes.bold"))),
                ]),
              ]
            ),
          ]),
        ]),
        _c("div", { staticClass: "section button-area" }, [
          _c(
            "button",
            {
              staticClass: "button cancel",
              on: { click: _vm.onNegativeClick },
            },
            [_vm._v(_vm._s(_vm.negative))]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }